import React from 'react';

const RecruitingAdvantage: React.FC = () => {
    const advantages = [
        {
            icon: '/career/share.svg',
            title: "Share Your Role",
            description: "Upload your job description in seconds."
        },
        {
            icon: '/career/goals.svg',
            title: "Refine Your Search",
            description: "Tell us about the nuances of the role, things that aren't on your job description."
        },
        {
            icon: '/career/ai_matching.svg',
            title: "AI Finds Candidates",
            description: "David only shares relevant and interested candidates with you."
        },
        {
            icon: '/career/connect.svg',
            title: "Streamline Hiring",
            description: "Once a match is made, David integrates into your existing workflow."
        }
    ];

    return (
        <section className="relative px-4 overflow-x-hidden" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
            <div className="container mx-auto max-w-[1640px]">
                <h2
                    className="text-left mb-8 sm:mb-16"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 7vw, 104px)',
                        lineHeight: 'clamp(38px, 8vw, 128px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Your recruiting advantage
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-[1600px] mx-auto">
                    {advantages.map((advantage, index) => (
                        <div
                            key={index}
                            className="w-full"
                            style={{
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: 'clamp(16px, 4vw, 32px) clamp(12px, 3vw, 24px)',
                                gap: 'clamp(12px, 3vw, 20px)',
                                maxWidth: '379px',
                                minHeight: 'clamp(200px, 30vw, 280px)',
                                background: 'rgba(20, 30, 48, 0.6)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: 'clamp(16px, 4vw, 24px)',
                                margin: '0 auto'
                            }}
                        >
                            {/* Icon */}
                            <img
                                src={advantage.icon}
                                alt={advantage.title}
                                style={{
                                    width: 'clamp(48px, 12vw, 80px)',
                                    height: 'clamp(48px, 12vw, 80px)',
                                    objectFit: 'contain',
                                    flex: 'none',
                                    order: 0,
                                    flexGrow: 0
                                }}
                            />

                            {/* Title */}
                            <h3
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    fontSize: 'clamp(14px, 3vw, 20px)',
                                    lineHeight: 'clamp(18px, 4vw, 28px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.01em',
                                    color: '#FFFFFF',
                                    margin: 0,
                                    flex: 'none',
                                    order: 1,
                                    flexGrow: 0
                                }}
                            >
                                {advantage.title}
                            </h3>

                            {/* Description */}
                            <p
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: 'clamp(11px, 2.5vw, 14px)',
                                    lineHeight: 'clamp(16px, 3vw, 20px)',
                                    textAlign: 'center',
                                    letterSpacing: '0em',
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    margin: 0,
                                    flex: 'none',
                                    order: 2,
                                    flexGrow: 0
                                }}
                            >
                                {advantage.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RecruitingAdvantage;
